export const tabletMediaQuery = "screen and (min-width: 768px)";
export const desktopMediaQuery = "screen and (min-width: 1024px)";
